import React from "react"
import moment from 'moment'
import cookie from "react-cookies"
import { connect } from "react-redux"
import { Link } from 'react-router-dom'
import { isIOS } from "react-device-detect"
import DateRangePicker from 'react-bootstrap-daterangepicker'
import "bootstrap-daterangepicker/daterangepicker.css"

import { commonErr } from "../common/errors"
import { parseAddressToLocation, calculateDistance, validateHourCityTour, validateWDMinHour } from "../common/wdfunction"
import { stypes , wdModes, wdTypes} from "../common/common"

import Header from "../common/header"
import Footer from "../common/footer"
import SideBar from "../common/sidebar"
import { MessageBox } from "../common/messagebox"

import InfoWDType from "./infopopup"
import HereAutoComplete from "../common/hereautocomplete"


const calendarTemplate = '<div class="daterangepicker dropdown-menu">' +
	'<div class="calendar left">' +
	'<div class="daterangepicker_input hidden">' +
	'<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
	'<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	'<div class="calendar-time">' +
	'<div></div>' +
	'<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	'</div>' +
	'</div>' +
	'<div class="calendar-table"></div>' +
	'</div>' +
	'</div>' +
	'</div>';

const bookingTimes = [];
for (var i = 0; i < 1440; i = i + 30) {
	const time = i;
	const hour = (time - time % 60) / 60;
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;
	bookingTimes.push({ value: time, label: `${hourLabel}:${minLabel}` });
}

const placesAutocompleteStyle = {
	autocompleteContainer: {
		position: 'absolute',
		top: '100%',
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		width: '100%',
		border: 'none',
		zIndex: '10000'
	},
	autocompleteItem: {
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		padding: '10px',
		color: '#f0f0f0',
		cursor: 'pointer'
	},
	autocompleteItemActive: {
		backgroundColor: '#6c6c6e',
		color: '#fffff',
	},
}



class OrderSearching extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			stype: stypes.WD,
			platformType: 0,
			userType: "",

			// sd 
			startDate: moment().set({
				hour: 21,
				minute: 0,
				second: 0,
				milliseconds: 0
			}),
			endDate: moment().add(1, "days").set({
				hour: 20,
				minute: 0,
				second: 0,
				milliseconds: 0
			}),
			address: "",

			// wd 
			startDatewd: moment().set({
				hour: 21,
				minute: 0,
				second: 0,
				milliseconds: 0
			}),
			endDatewd: moment().add(1, "days").set({
				hour: 20,
				minute: 0,
				second: 0,
				milliseconds: 0
			}),
			// isCityTourMode: true,
			wdMode: wdModes.CITY_TOUR,
			addressArray: ["", ""],
			locationArray: [undefined, undefined],
			wdDistance: 0,
			wdDistanceBackOW: 0,
			hourValidateResult: -1,
			wdOneWay: false,
			showInfoWdType: false
			
		}

		this.onStartDateChange = this.onStartDateChange.bind(this);
		this.onDateRangeChange = this.onDateRangeChange.bind(this);
		this.onStartTimeChange = this.onStartTimeChange.bind(this);
		this.onEndTimeChange = this.onEndTimeChange.bind(this);
		this.findCar = this.findCar.bind(this);
		this.onAddressFocus = this.onAddressFocus.bind(this);
		this.onAddressChange = this.onAddressChange.bind(this);
		this.onSelectFromAddr = this.onSelectFromAddr.bind(this);
		this.hideMessageBox = this.hideMessageBox.bind(this);

		this.onWDModeChange = this.onWDModeChange.bind(this);
		this.onRemoveStopPoint = this.onRemoveStopPoint.bind(this);
		this.onAddStopPoint = this.onAddStopPoint.bind(this);
		this.onWDWayCheckBoxChange = this.onWDWayCheckBoxChange.bind(this); 
	
		this.checkValidateTypeMinHour = this.checkValidateTypeMinHour.bind(this);

		this.setSdView = this.setSdView.bind(this);
		this.setWdView = this.setWdView.bind(this);
		this.showInfoWdType = this.showInfoWdType.bind(this);
		this.closeInfoWdType = this.closeInfoWdType.bind(this);

	}

	componentDidMount() {
	
		const address = cookie.load("_maddr") || "";

		this.setState({
			address: address,
		})

		var startDate;
		var endDate;
		var startTime;
		var endTime;

		// check valid cookie before set
		if (cookie.load("_mstartts") < moment().add(2, "hours").valueOf() || cookie.load("_mendts") < moment().add(2, "hours").valueOf()) {
			cookie.remove("_mstartts", { path: '/' });
			cookie.remove("_mendts", { path: '/' });
		}

		const cStartTs = cookie.load("_mstartts");
		const cEndTs = cookie.load("_mendts");

		if (cStartTs && cEndTs) {
			const cStartDate = moment(cStartTs * 1);
			const cEndDate = moment(cEndTs * 1);
			startDate = cStartDate;
			endDate = cEndDate;
			startTime = cStartDate.get("hour") * 60 + startDate.get("minute");
			endTime = cEndDate.get("hour") * 60 + endDate.get("minute");
		}

		if (startDate && endDate) {
			this.setState({
				startDate: startDate,
				endDate: endDate,
				startTime: startTime,
				endTime: endTime,
			})
		} else {
			if (this.props.appInit.err === commonErr.SUCCESS)
				this.setState({
					startDate: moment(this.props.appInit.data.startTime),
					endDate: moment(this.props.appInit.data.endTime),
					startTime: moment(this.props.appInit.data.startTime).get("hour") * 60 + moment(this.props.appInit.data.startTime).get("minute"),
					endTime: moment(this.props.appInit.data.endTime).get("hour") * 60 + moment(this.props.appInit.data.endTime).get("minute"),
				});
		}

		// var isCityTourMode = true;
		var wdMode = wdModes.CITY_TOUR;
		var wdOneWay = false;
		var addressArray = ["", ""];
		var locationArray = [undefined, undefined];
		var wdDistance = 0;
		var wdDistanceBackOW = 0;

		// cookie
		const cRoutes = cookie.load("_mbizroutes");

		if (cRoutes) {
			wdMode = cRoutes[0]
			wdDistance = cRoutes[1]
			let wdLocations = cRoutes[2]
			wdOneWay = cRoutes[3]
			wdDistanceBackOW = cRoutes[4]
			let tempArray = wdLocations.split(",")
			locationArray = []
			addressArray = []

			if (!cRoutes[3] && wdMode === 1) { 
				tempArray.splice(tempArray.length-1,1)
			}

			for (let i = 0; i < tempArray.length; i++) {
				let tempArray1 = tempArray[i].split("-")
				locationArray.push({ lat: parseFloat(tempArray1[0]), lng: parseFloat(tempArray1[1]) })
				addressArray.push(Buffer.from(tempArray1[2], 'base64').toString())
			}
		}

		this.setState({
			// isCityTourMode,
			addressArray,
			locationArray,
			wdDistance,
			wdOneWay,
			wdDistanceBackOW,
			wdMode
		})


		if (this.props.appInit.data) {
			var startDatewd;
			var endDatewd;
			var startTimewd;
			var endTimewd;
			const { wdStartTime, wdEndTime } = this.props.appInit.data;

			// check valid cookie before set
			if (cookie.load("_mstarttswd") < moment().add(2, "hours").valueOf() || cookie.load("_mendtswd") < moment().add(2, "hours").valueOf()) {
				cookie.remove("_mstarttswd", { path: '/' });
				cookie.remove("_mendtswd", { path: '/' });
			}

			const cStartTs = cookie.load("_mstarttswd");
			const cEndTs = cookie.load("_mendtswd");

			if (cStartTs && cEndTs) {
				const cStartDate = moment(cStartTs * 1);
				const cEndDate = moment(cEndTs * 1);
				startDatewd = cStartDate;
				endDatewd = cEndDate;
				startTimewd = cStartDate.get("hour") * 60 + startDatewd.get("minute");
				endTimewd = cEndDate.get("hour") * 60 + endDatewd.get("minute")
			}

			if (startDatewd && endDatewd) {
				if (!addressArray.includes("")) {
					//check min hour
					calculateDistance(locationArray, wdOneWay, (distance, distanceBackOW) => {
						this.setState({
							startDatewd: startDatewd,
							endDatewd: endDatewd,
							startTimewd: startTimewd,
							endTimewd: endTimewd,
							wdDistance: distance,
							wdDistanceBackOW: distanceBackOW,
							hourValidateResult: this.checkValidateTypeMinHour(distance, startDatewd, endDatewd)
						})
					})

				} else {
					this.setState({
						startDatewd: startDatewd,
						endDatewd: endDatewd,
						startTimewd: startTimewd,
						endTimewd: endTimewd
					})
				}

			} else if (this.props.appInit.err === commonErr.SUCCESS) {

				if (!addressArray.includes("")) {
					calculateDistance(locationArray, wdOneWay, (distance, distanceBackOW) => {
						this.setState({
							startDatewd: moment(wdStartTime),
							endDatewd: moment(wdEndTime),
							startTimewd: moment(wdStartTime).get("hour") * 60 + moment(wdStartTime).get("minute"),
							endTimewd: moment(wdEndTime).get("hour") * 60 + moment(wdEndTime).get("minute"),
							wdDistance: distance,
							wdDistanceBackOW: distanceBackOW,
							hourValidateResult: this.checkValidateTypeMinHour(distance, wdStartTime, wdEndTime)
						});
					})
				} else {
					this.setState({
						startDatewd: moment(wdStartTime),
						endDatewd: moment(wdEndTime),
						startTimewd: moment(wdStartTime).get("hour") * 60 + moment(wdStartTime).get("minute"),
						endTimewd: moment(wdEndTime).get("hour") * 60 + moment(wdEndTime).get("minute")
					});
				}
			}
		}

	}

	componentWillReceiveProps(props) {
	
		//-- SelfDriver

		if (cookie.load("_mstartts") > moment().add(2, "hours").valueOf() && cookie.load("_mendts") > moment().add(2, "hours").valueOf()) {
			const cStartTs = cookie.load("_mstartts") * 1;
			const cEndTs = cookie.load("_mendts") * 1;
			if (cStartTs && cEndTs) {
				this.setState({
					startDate: moment(cStartTs),
					endDate: moment(cEndTs),
					startTime: moment(cStartTs).get("hour") * 60 + moment(cStartTs).get("minute"),
					endTime: moment(cEndTs).get("hour") * 60 + moment(cEndTs).get("minute")
				})
			}
		} else {
			if (props.appInit.data.startTime !== this.props.appInit.data.startTime
				&& props.appInit.data.endTime !== this.props.appInit.data.endTime) {
				this.setState({
					startDate: moment(props.appInit.data.startTime),
					endDate: moment(props.appInit.data.endTime),
					startTime: moment(props.appInit.data.startTime).get("hour") * 60 + moment(props.appInit.data.startTime).get("minute"),
					endTime: moment(props.appInit.data.endTime).get("hour") * 60 + moment(props.appInit.data.endTime).get("minute"),
				});
			}
		}


		//-- With Driver
		// var isCityTourMode;
		var wdMode = wdModes.CITY_TOUR;
		var wdOneWay = false;
		var addressArray = ["", ""];
		var locationArray = [undefined, undefined];
		var wdDistance = 0;
		var wdDistanceBackOW = 0;
		// cookie
		const cRoutes = cookie.load("_mbizroutes");

		if (cRoutes) {
			wdMode = cRoutes[0]
			wdDistance = cRoutes[1]
			let wdLocations = cRoutes[2]
			wdOneWay  = cRoutes[3]
			wdDistanceBackOW = cRoutes[4]
			let tempArray = wdLocations.split(",")
			locationArray = []
			addressArray = []

			if (!cRoutes[3] && cRoutes[0] === 1) { 
				tempArray.splice(tempArray.length-1,1)
			}

			for (let i = 0; i < tempArray.length; i++) {
				let tempArray1 = tempArray[i].split("-")
				locationArray.push({ lat: parseFloat(tempArray1[0]), lng: parseFloat(tempArray1[1]) })
				addressArray.push(Buffer.from(tempArray1[2], 'base64').toString())
			}

		
		}
		

		this.setState({

			addressArray,
			locationArray,
			wdDistance,
			wdOneWay,
			wdDistanceBackOW,
			wdMode
		})

		if (props.appInit.data) {
			var startDatewd;
			var endDatewd;
			const { wdStartTime, wdEndTime } = props.appInit.data;

			if (cookie.load("_mstarttswd") > moment().add(2, "hours").valueOf() && cookie.load("_mendtswd") > moment().add(2, "hours").valueOf()) {
				const cStartTs = cookie.load("_mstarttswd") * 1;
				const cEndTs = cookie.load("_mendtswd") * 1;
			
				if (cStartTs && cEndTs) {
					const cStartDate = moment(cStartTs * 1);
					const cEndDate = moment(cEndTs * 1);
					startDatewd = cStartDate;
					endDatewd = cEndDate;
					
					if (!this.state.addressArray.includes("")) {
					
						calculateDistance(locationArray, wdOneWay, (distance, distanceBackOW) => {
							this.setState({
								startDatewd: moment(cStartTs),
								endDatewd: moment(cEndTs),
								startTimewd: moment(cStartTs).get("hour") * 60 + moment(cStartTs).get("minute"),
								endTimewd: moment(cEndTs).get("hour") * 60 + moment(cEndTs).get("minute"),
								wdDistance: distance,
								wdDistanceBackOW: distanceBackOW,
								hourValidateResult: this.checkValidateTypeMinHour(distance, startDatewd, endDatewd)
							})
						})

					} else {
						this.setState({
							startDatewd: moment(cStartTs),
							endDatewd: moment(cEndTs),
							startTimewd: moment(cStartTs).get("hour") * 60 + moment(cStartTs).get("minute"),
							endTimewd: moment(cEndTs).get("hour") * 60 + moment(cEndTs).get("minute")
						})
					}

				}
			} else {
				if (props.appInit.data.wdStartTime !== this.props.appInit.data.wdStartTime
					&& props.appInit.data.wdEndTime !== this.props.appInit.data.wdEndTime) {

					if (!this.state.addressArray.includes("")) {
						calculateDistance(locationArray, wdOneWay, (distance, distanceBackOW) => {
							this.setState({
								startDatewd: moment(wdStartTime),
								endDatewd: moment(wdEndTime),
								startTimewd: moment(wdStartTime).get("hour") * 60 + moment(wdStartTime).get("minute"),
								endTimewd: moment(wdEndTime).get("hour") * 60 + moment(wdEndTime).get("minute"),
								wdDistance: distance,
								wdDistanceBackOW: distanceBackOW,
								hourValidateResult: this.checkValidateTypeMinHour(distance, wdStartTime, wdEndTime)
							});
						})

					} else {
						this.setState({
							startDatewd: moment(wdStartTime),
							endDatewd: moment(wdEndTime),
							startTimewd: moment(wdStartTime).get("hour") * 60 + moment(wdStartTime).get("minute"),
							endTimewd: moment(wdEndTime).get("hour") * 60 + moment(wdEndTime).get("minute")
						});
					}
				}
			}
		}
	}

	onStartDateChange(event, picker) {
	
		if (this.state.stype === stypes.WD) {
			let { wdDistance} = this.state

			// if (isCityTourMode) wdDistance = 0;
			if (picker.startDate) {
				const startDatewd = picker.startDate;
				var endDatewd = this.state.endDatewd;
				var endTimewd = this.state.endTimewd;
				startDatewd.set({
					hour: (this.state.startTimewd - this.state.startTimewd % 60) / 60,
					minute: this.state.startTimewd % 60,
					second: 0,
					milliseconds: 0
				});
	
				if (endDatewd <= startDatewd) {
					endDatewd = startDatewd.clone();
					endDatewd.add(23, "hour");
					endTimewd = moment(endDatewd).get("hour") * 60 + moment(endDatewd).get("minute");
				}
	
				//save cookies
				cookie.save("_mstarttswd", startDatewd.valueOf(), { path: '/' });
				cookie.save("_mendtswd", endDatewd.valueOf(), { path: '/' });
	
			
				// validate hour
				this.setState({
					startDatewd: startDatewd,
					endDatewd: endDatewd,
					endTimewd: endTimewd,
					hourValidateResult: this.checkValidateTypeMinHour(wdDistance, startDatewd, endDatewd)
				})
			}
		} 

		if (picker.startDate) {
			const startDate = picker.startDate;
			var endDate = this.state.endDate;
			var endTime = this.state.endTime;
			startDate.set({
				hour: (this.state.startTime - this.state.startTime % 60) / 60,
				minute: this.state.startTime % 60,
				second: 0,
				milliseconds: 0
			});

			if (endDate <= startDate) {
				endDate = startDate.clone();
				endDate.add(23, "hour");
				endTime = moment(endDate).get("hour") * 60 + moment(endDate).get("minute");
			}

			//save cookies
			cookie.save("_mstartts", startDate.valueOf(), { path: '/' });
			cookie.save("_mendts", endDate.valueOf(), { path: '/' });

			// this.toggleSearching();
			this.setState({
				startDate: startDate,
				endDate: endDate,
				endTime: endTime,
			})
			// this.toggleSearching();
		}
		
	}

	onDateRangeChange(event, picker) {

		if (this.state.stype === stypes.WD) {

			let { wdDistance, startTimewd, endTimewd} = this.state
			// if (isCityTourMode) wdDistance = 0;
			if (picker.startDate && picker.endDate) {
				const startDatewd = picker.startDate;
				startDatewd.set({
					hour: (startTimewd - startTimewd % 60) / 60,
					minute: startTimewd % 60,
					second: 0,
					milliseconds: 0
				});
				const endDatewd = picker.endDate;
				endDatewd.set({
					hour: (endTimewd - endTimewd % 60) / 60,
					minute: endTimewd % 60,
					second: 0,
					milliseconds: 0
				});
				if (endDatewd < startDatewd) {
					return;
				}
	
				//save cookies
				cookie.save("_mstarttswd", startDatewd.valueOf(), { path: '/' });
				cookie.save("_mendtswd", endDatewd.valueOf(), { path: '/' });
				this.setState({
					startDatewd: startDatewd,
					endDatewd: endDatewd,
					hourValidateResult: this.checkValidateTypeMinHour(wdDistance, startDatewd, endDatewd)
				})
			}
		}
		if (picker.startDate && picker.endDate) {
			const startDate = picker.startDate;
			startDate.set({
				hour: (this.state.startTime - this.state.startTime % 60) / 60,
				minute: this.state.startTime % 60,
				second: 0,
				milliseconds: 0
			});
			const endDate = picker.endDate;
			endDate.set({
				hour: (this.state.endTime - this.state.endTime % 60) / 60,
				minute: this.state.endTime % 60,
				second: 0,
				milliseconds: 0
			});
			if (endDate < startDate) {
				return;
			}

			//save cookies
			cookie.save("_mstartts", startDate.valueOf(), { path: '/' });
			cookie.save("_mendts", endDate.valueOf(), { path: '/' });
			this.setState({
				startDate: startDate,
				endDate: endDate
			})
		}
	}

	

	onStartTimeChange(event) {
		const time = event.target.value;
		const hour = (time - time % 60) / 60;
		const min = time % 60;

		const startDate = moment(this.state.startDate).set({
			hour: hour,
			minute: min,
			second: 0,
			milliseconds: 0
		});

		if (this.state.endDate && this.state.endDate.isValid() && this.state.endDate <= startDate) {
			this.setState({
				startDate: this.state.endDate,
				endDate: startDate,
				startTime: this.state.endTime,
				endTime: time,
				err: commonErr.FAIL,
				errMsg: "Thời gian thuê xe không hợp lệ."
			});
		} else {
			cookie.save("_mstartts", startDate.valueOf(), { path: '/' });
			this.setState({
				startDate: startDate,
				startTime: time,
				err: commonErr.SUCCESS,
				errMsg: ""
			});
		}

		if (this.state.stype === stypes.WD) {
			let { wdDistance, endDatewd, endTimewd, wdMinHour, isCityTourMode } = this.state
			// if (isCityTourMode) wdDistance = 0;
			const startDatewd = moment(this.state.startDatewd).set({
				hour: hour,
				minute: min,
				second: 0,
				milliseconds: 0
			});
	
			if (endDatewd && endDatewd.isValid() && endDatewd <= startDatewd) {
				this.setState({
					startDatewd: endDatewd,
					endDatewd: startDatewd,
					startTimewd: endTimewd,
					endTimewd: time,
					err: commonErr.FAIL,
					errMsg: "Thời gian thuê xe không hợp lệ."
				});
			} else {
				cookie.save("_mstarttswd", startDatewd.valueOf(), { path: '/' });
				this.setState({
					startDatewd: startDatewd,
					startTimewd: time,
					err: commonErr.SUCCESS,
					errMsg: "",
					hourValidateResult: this.checkValidateTypeMinHour(wdDistance, startDatewd, endDatewd)
				});
			}
		}
	
	}

	onEndTimeChange(event) {
		const time = event.target.value;
		const hour = (time - time % 60) / 60;
		const min = time % 60;

		if (this.state.endDate && this.state.endDate.isValid()) {
		
			const endDate = moment(this.state.endDate).set({
				hour: hour,
				minute: min,
				second: 0,
				milliseconds: 0
			})
			if (endDate <= this.state.startDate) {
				this.setState({
					endDate: this.state.startDate,
					startDate: endDate,
					endTime: this.state.startTime,
					startTime: time,
					err: commonErr.FAIL,
					errMsg: "Thời gian thuê xe không hợp lệ."
				});
			} else {
				cookie.save("_mendts", endDate.valueOf(), { path: '/' });
				this.setState({
					endDate: endDate,
					endTime: time,
					err: commonErr.SUCCESS,
					errMsg: ""
				});
			}
		} else {
			this.setState({
				endTime: time,
				err: commonErr.SUCCESS,
				errMsg: ""
			});
		}
		if (this.state.stype === stypes.WD) {
		
			let { wdDistance, startTimewd, startDatewd} = this.state
			// if (isCityTourMode) wdDistance = 0;

			if (this.state.endDatewd && this.state.endDatewd.isValid()) {
				const endDatewd = moment(this.state.endDatewd).set({
					hour: hour,
					minute: min,
					second: 0,
					milliseconds: 0
				})
				if (endDatewd <= startDatewd) {
					this.setState({
						endDatewd: startDatewd,
						startDatewd: endDatewd,
						endTimewd: startTimewd,
						startTimewd: time,
						err: commonErr.FAIL,
						errMsg: "Thời gian thuê xe không hợp lệ."
					});
				} else {
					cookie.save("_mendtswd", endDatewd.valueOf(), { path: '/' });
					this.setState({
						endDatewd: endDatewd,
						endTimewd: time,
						err: commonErr.SUCCESS,
						errMsg: "",
						hourValidateResult: this.checkValidateTypeMinHour(wdDistance, startDatewd, endDatewd)
	
					});
				}
			} else {
				this.setState({
					endTimewd: time,
					err: commonErr.SUCCESS,
					errMsg: "",
					hourValidateResult: this.checkValidateTypeMinHour(wdDistance, startDatewd, this.state.endDatewd)
				});
			}
		}
	}


	findCar(e) {

		const { stype, address, addressArray, hourValidateResult, wdMode } = this.state;

		if(stype === stypes.SD){ 
			if (!address || address === "") {
				this.setState({
					err: commonErr.FAIL,
					errMsg: "Vui lòng nhập địa chỉ để tìm kiếm."
				});
				e.preventDefault();
				return false;
			}
		}
		

		if (stype === stypes.WD) {
			
			if (!addressArray[0] || addressArray[0] === "") {
				this.setState({
					err: commonErr.FAIL,
					errMsg: "Vui lòng nhập địa chỉ để tìm kiếm."
				});
				e.preventDefault();
				return false;
			} else if (wdMode === wdModes.PROVINCE && addressArray.includes("")) {
				this.setState({
					err: commonErr.FAIL,
					errMsg: "Vui lòng nhập địa chỉ còn trống."
				});
				e.preventDefault();
				return false;
			} else if (hourValidateResult !== -1) {
				this.setState({
					err: commonErr.FAIL,
					errMsg: "Vui lòng chọn lại thời gian. Thời gian thuê tối thiểu cho lộ trình trên là " + hourValidateResult + " tiếng."
				});
				e.preventDefault();
	
			} else if (hourValidateResult === -2) { // when in time checking hour, prevent search
				e.preventDefault();
			} else {
				// success
				const { wdMode, wdDistance, wdOneWay, wdDistanceBackOW, addressArray, locationArray} = this.state
			
				let wdLocations = "";

				if(wdMode === wdModes.CITY_TOUR && addressArray.length > 1) { 

					wdLocations = `${locationArray[0].lat}-${locationArray[0].lng}-${Buffer.from(addressArray[0]).toString('base64')}`
					
				} else if (wdMode === wdModes.PROVINCE && !wdOneWay) { 
			
					for (let i = 0; i < addressArray.length; i++) {
						wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString('base64')}${i !== addressArray.length ? ',' : ''}`
					}
						wdLocations+=`${locationArray[0].lat}-${locationArray[0].lng}-${Buffer.from(addressArray[0]).toString('base64')}`
				}  else {

					for (let i = 0; i < addressArray.length; i++) {
						wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString('base64')}${i !== addressArray.length - 1 ? ',' : ''}`
					}
					
				}
			
				cookie.save("_mbizroutes", [wdMode, wdDistance, wdLocations, wdOneWay, wdDistanceBackOW],  { path: '/' }) 	;
			
				
			}
		}
	
	}

	onAddressFocus = (e, i) => {
		if (this.state.stype === stypes.WD) {
			let addressArrayTemp = [...this.state.addressArray]
			addressArrayTemp[i] = ""
			let locationArrayTemp = [...this.state.locationArray]
			locationArrayTemp[i] = undefined
			this.setState({
				addressArray: addressArrayTemp,
				locationArray: locationArrayTemp,
				hourValidateResult: -1,
			});
		} else { 
			this.setState({
				address: "",
			});
		}
		
	}

	onAddressChange(address, i) {
	
		if (this.state.stype === stypes.WD) {
			let addressArrayTemp = [...this.state.addressArray]
			addressArrayTemp[i] = address
			this.setState({
				addressArray: addressArrayTemp
			})
		} else { 
			this.setState({
				address: address
			})
		}
		
	}

	onSelectFromAddr = (address, i) =>{

		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg = "Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg
			});
			
		} 
		if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} 

		let { stype, addressArray, startDatewd, endDatewd, locationArray, wdOneWay, wdMode} = this.state;
		const { wdMinHourCT } = this.props.appInit.data

		if (stype === stypes.SD) {
			this.setState({
				err: commonErr.SUCCESS,
				address: address.address
			})
		} 

		if (stype === stypes.WD) {

			let addressArrayTemp = [...addressArray]
			addressArrayTemp[i] = address.address
		

			// parse location
			parseAddressToLocation(address.address, address.lat, address.lng, (location) => {
			
				let locationArrayTemp = [...locationArray]
				locationArrayTemp[i] = location 
		
				if (wdMode === wdModes.CITY_TOUR) {
					this.setState({
						err: commonErr.SUCCESS,
						addressArray: addressArrayTemp,
						locationArray: locationArrayTemp,
						hourValidateResult: validateHourCityTour(startDatewd, endDatewd, wdMinHourCT)
					})
				}
			
				if (wdMode === wdModes.PROVINCE) {
					if (addressArrayTemp.includes("")) {
						// only set state
						this.setState({
							err: commonErr.SUCCESS,
							addressArray: addressArrayTemp,
							locationArray: locationArrayTemp,
						})
					} else {
						// compute distance
						calculateDistance(locationArrayTemp, wdOneWay, (distance, distanceBackOW) => {
							this.setState({
								err: commonErr.SUCCESS,
								addressArray: addressArrayTemp,
								locationArray: locationArrayTemp,
								wdDistance: distance,
								wdDistanceBackOW: distanceBackOW,
								hourValidateResult: this.checkValidateTypeMinHour(distance, startDatewd, endDatewd)
							})
						})
					}
				}
					
				
			})
		}

	}
	
	onWDModeChange(wdMode) {

		let { addressArray, locationArray, startDatewd, endDatewd, wdOneWay } = this.state;
		const { wdMinHourCT } = this.props.appInit;
		let addressArrayTemp;
		let locationArrayTemp; 

		this.setState({
			wdMode
		})

		if (wdMode === wdModes.CITY_TOUR) { 

			if (addressArray.length > 1 && locationArray.length > 1) { 
				addressArrayTemp = addressArray.splice(0,1)
				locationArrayTemp = locationArray.splice(0,1)
			} else { 
				addressArrayTemp = addressArray;
				locationArrayTemp = locationArray;
			}
			
			this.setState({
				addressArray: addressArrayTemp,
				locationArray: locationArrayTemp,
				wdDistance: 0,
				hourValidateResult: validateHourCityTour(startDatewd, endDatewd, wdMinHourCT),
				wdOneWay: false, 
				wdDistanceBackOW: 0
			})
		
		}  else { 
			if(addressArray.length === 1) {
				addressArray.push("");
				locationArray.push(undefined)
			}
			if(addressArray.length > 1 && locationArray.length > 1 && !addressArray.includes("")) { 
					calculateDistance(locationArray, wdOneWay, (distance, distanceBackOW) => {
						this.setState({
							wdOneWay, 
							wdDistance: distance,
							wdDistanceBackOW: distanceBackOW,
							hourValidateResult: this.checkValidateTypeMinHour(distance, startDatewd, endDatewd),
						})
					})
			}
	

		}
	
	}


	onRemoveStopPoint(i) {
	
		let { addressArray, locationArray, startDatewd, endDatewd, wdOneWay} = this.state
		let addressArrayTemp = [...addressArray]
		addressArrayTemp.splice(i, 1)
		let locationArrayTemp = [...locationArray]
		locationArrayTemp.splice(i, 1)

		if (addressArrayTemp.includes("")) {
			// not validate hour
			this.setState({
				addressArray: addressArrayTemp,
				locationArray: locationArrayTemp
			})
		} else {
			// compute distance
			// validate hour
			calculateDistance(locationArrayTemp, wdOneWay, (distance, distanceBackOW) => {
				this.setState({
					addressArray: addressArrayTemp,
					locationArray: locationArrayTemp,
					wdDistance: distance,
					wdDistanceBackOW: distanceBackOW,
					hourValidateResult: this.checkValidateTypeMinHour(distance, startDatewd, endDatewd)
				})
			})
		}
		
	}

	onAddStopPoint() {
		let { addressArray, locationArray } = this.state
		if (addressArray.length >= 5) return;
	
		this.setState({
			addressArray: [...addressArray, ""],
			locationArray: [...locationArray, undefined]
		})
		
	}

	onWDWayCheckBoxChange(e) { 
		let { startDatewd, endDatewd, locationArray, wdOneWay, addressArray } = this.state;
		let { wdMinHour, wdMinHourOW } = this.props.appInit.data
		

		if (!addressArray.includes("")) {
			this.setState({
				wdOneWay: !wdOneWay
			}, () => {
		
				calculateDistance(locationArray, !wdOneWay, (distance, distanceBackOW) => {
					this.setState({
						err: commonErr.SUCCESS,
						wdDistance: distance,
						wdDistanceBackOW: distanceBackOW,
						hourValidateResult: !wdOneWay ? validateWDMinHour(wdMinHourOW, distance, startDatewd, endDatewd) : validateWDMinHour(wdMinHour, distance, startDatewd, endDatewd)
					})
				})

			 })
		} else { 
			e.preventDefault();

			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng nhập địa chỉ tìm kiếm"
			})
		}
	
	}


	formatAddressArrayForQuery() {
		let { addressArray } = this.state
		let result = ""
		for (let i = 0; i < addressArray.length - 1; i++) {
			result += `${addressArray[i]};`
		}
		result += addressArray[addressArray.length - 1]
		return result
	}

	checkValidateTypeMinHour(distance, startDatewd, endDatewd) {

		const {wdMode, wdOneWay} = this.state;
		const {wdMinHourCT, wdMinHourOW, wdMinHour} = this.props.appInit.data 
		let result = -1;

		if(wdMode === wdModes.CITY_TOUR) {
			result = validateHourCityTour(startDatewd, endDatewd, wdMinHourCT)
		} else if (wdMode === wdModes.PROVINCE && wdOneWay) {
			result = validateWDMinHour(wdMinHourOW, distance, startDatewd, endDatewd)  
		} else {
			result = validateWDMinHour(wdMinHour, distance, startDatewd, endDatewd)
		}

		return result
	}
 

	hideMessageBox() {
		this.setState({
			errMsg: ""
		});
	}

	setSdView() {
		this.setState({
			stype: stypes.SD
		});
	}

	setWdView() {
		this.setState({
			stype: stypes.WD
		});
	}

	showInfoWdType() {
		this.setState({
			showInfoWdType: true
		})
	}

	closeInfoWdType() {
		this.setState({
			showInfoWdType: false
		})
	}


	render() {
		var content;
		const { platformType } = this.props.appInit;
		const { stype, address, startDate, endDate, startTime, endTime, wdOneWay, wdMode, addressArray, showInfoWdType, errMsg } = this.state;
		let wdType = wdMode === 0 ? wdTypes.CITY_TOUR : (wdMode === 1 && wdOneWay) ? wdTypes.ONEWAY : wdTypes.TWOWAY;
		
		if (stype === stypes.SD) {
				content = <div className="order-searching__box">
					<div className="form-group mb-4">
					<label className="home-label">Địa điểm</label>
					<div className="input-group-icon input-group-icon-left">
						<span className="input-icon input-icon-left"><i className="ic ic-location-f" /></span>		
						{/* <PlacesAutocomplete
									classNames={{ input: "form-control form-control-line" }}
									inputProps={{
										value: address,
										onChange: this.onAddressChange,
										onFocus: this.onAddressFocus,
										placeholder: "Nhập thành phố, quận, địa chỉ..."
									}}
									styles={placesAutocompleteStyle}
									onSelect={(address) => this.onSelectFromAddr(address, 0)}
									isUseCurrentLocation={true}
									googleLogo={false}
							options={{ componentRestrictions: { country: ['vn'] } }} /> */}
						<HereAutoComplete 
							inputProps={{
								value: address,
								onChange: this.onAddressChange,
								onFocus: this.onAddressFocus,
								placeholder: "Nhập thành phố, quận, địa chỉ..."
							}}
							styles={placesAutocompleteStyle}
							focusAddress={true}
							onSelect={(address) => this.onSelectFromAddr(address, 0)} />
							{this.state.errMsg}
					</div>
				</div>
					
				<div className="form-group mb-4">
						<label className="home-label">Bắt đầu</label>
						<div className="d-flex">
							<div className="form-control form-control-line">
							<DateRangePicker 
										startDate={startDate}
										endDate={startDate}
										minDate={moment()}
										maxDate={moment().add(3, "months")}
										timePicker={false}
										singleDatePicker={true}
										singleSelect={true}
										autoApply={true}
										isIOs={isIOS}
										timePickerIncrement={30}
										linkedCalendars={false}
										timePicker24Hour={true}
										onHide={this.onStartDateChange.bind(this)}
										buttonClasses={["hidden"]}
										opens={"center"}
										template={calendarTemplate}
										parentEl={"#home-box"}>
										<span className="value">{startDate ? startDate.format("DD/MM/YYYY") : "Chọn ngày"} <i className="i-chevron-down"></i></span>
								</DateRangePicker>
							</div>
							<select style={{height: "auto"}}  className="form-control form-control-line" onChange={this.onStartTimeChange.bind(this)} value={startTime}>
									{bookingTimes.map(time => <option key={`s_${time.value}`} value={time.value}>{time.label} </option>)}
								</select>
						</div>
				
				</div>
				<div className="form-group mb-4">
						<label className="home-label">Kết thúc</label>
						<div className="d-flex">
							<div className="form-control form-control-line">
							<DateRangePicker
									startDate={startDate}
									endDate={endDate}
									minDate={moment(startDate.valueOf())}
									maxDate={moment().add(3, "months")}
									timePicker={false}
									singleDateRangePicker={true}
									singleSelect={true}
									autoApply={true}
									isIOs={isIOS}
									timePickerIncrement={30}
									linkedCalendars={false}
									timePicker24Hour={true}
									pickingEndDateOnly={true}
									onHide={this.onDateRangeChange.bind(this)}
									buttonClasses={["hidden"]}
									opens={"center"}
									template={calendarTemplate}
									parentEl={"#home-box"}>
									<span className="value">{endDate ? endDate.format("DD/MM/YYYY") : "Chọn ngày"} <i className="i-chevron-down"></i></span>
								</DateRangePicker>
								
							</div>
							<select style={{height: "auto"}} className="form-control form-control-line" onChange={this.onEndTimeChange.bind(this)} value={endTime}>
									{bookingTimes.map(time => <option key={`e_${time.value}`} value={time.value}>{time.label} </option>)}
								</select>
						</div>
					</div>
					<div className="fn-search text-center">
						<Link className="btn btn-primary" onClick={this.findCar} to={{
								pathname: `/find/filter`,
								search: `startDate=${this.state.startDate.valueOf()}&endDate=${this.state.endDate.valueOf()}&address=${this.state.address}&platformType=${platformType}`
							}}>
								<span>TÌM XE NGAY</span>
							</Link>
					</div>
				</div>
		}else {
			content = <div className="order-searching__box"> 
							<div className="form-group mb-4">
								<ul className="nav nav-tabs tabs-line tabs-line-2x nav-fill">
									<li className="nav-item">
										<a className={`nav-link ${wdMode === wdModes.CITY_TOUR ? "active" : ""}`} onClick={() => this.onWDModeChange(wdModes.CITY_TOUR)}>Nội thành</a>
									</li>
									<li className="nav-item">
										<a className={`nav-link ${wdMode === wdModes.PROVINCE ? "active" : ""}`}  onClick={() => this.onWDModeChange(wdModes.PROVINCE)}>Liên tỉnh</a>
									</li>
								</ul>

								<div className="tab-content">
									{wdMode === wdModes.CITY_TOUR && <div id="cityTour" className={`w-100 tab-pane ${wdMode === wdModes.CITY_TOUR ? "fade show active" : ""}`}>
										<label className="home-label">Điểm đón</label>
										<div className="wrap-input input-group-icon input-group-icon-left">
											<span className="input-icon input-icon-left"><i className="ic ic-start-location" /></span>	
											{/* <PlacesAutocomplete
												classNames={{ input: "form-control form-control-line" }}
												inputProps={{
													value: this.state.addressArray[0],
													onChange: (address) => this.onAddressChange(address, 0),
													onFocus: (e) => this.onAddressFocus(e, 0),
													placeholder: "Tôi muốn đón tại"
												}}
												styles={placesAutocompleteStyle}
												onSelect={(address) => this.onSelectFromAddr(address, 0)}
												isUseCurrentLocation={true}
												googleLogo={false}
												options={{ componentRestrictions: { country: ['vn'] } }}
											/> */}
											<HereAutoComplete 
												styles={placesAutocompleteStyle}
												onSelect={(address) => this.onSelectFromAddr(address, 0)}
												focusAddress={true}
												inputProps={{
													value: this.state.addressArray[0],
													onChange: (address) => this.onAddressChange(address, 0),
													onFocus: (e) => this.onAddressFocus(e, 0),
													placeholder: addressArray[0],
												}} />
										</div>
										<p className="notice">Di chuyển xe trong thành phố. <a className="text-primary" onClick={this.showInfoWdType}>Tìm hiểu thêm</a></p>
									</div> }

									{wdMode === wdModes.PROVINCE && <div id="province" className={`w-100 tab-pane ${wdMode === wdModes.PROVINCE ? "fade show active" : ""}`}>
										<label className="home-label">Lộ trình</label>
									
										{addressArray.map((address, index) => {
											return <div className="wrap-input input-group-icon input-group-icon-left" key={index}>
												<span className="input-icon input-icon-left"><i className={index === 0 ? "ic ic-start-location" : "ic ic-sm-circle-fill"} /></span>
												<div>
													{/* <PlacesAutocomplete
														classNames={{ input: "form-control form-control-line" }}
														inputProps={{
															value: address,
															onChange: (address) => this.onAddressChange(address, index),
															onFocus: (e) => this.onAddressFocus(e, index),
															placeholder: index === 0 ? "Tôi muốn đón tại..." : "Tôi muốn đến..."
													}}
													styles={placesAutocompleteStyle}
													onSelect={(address) => this.onSelectFromAddr(address, index)}
													isUseCurrentLocation={index === 0}
													googleLogo={false}
													options={{ componentRestrictions: { country: ['vn'] } }}
													/> */}
													<HereAutoComplete 
														styles={placesAutocompleteStyle}
														onSelect={(address) => this.onSelectFromAddr(address, index)}
														focusAddress={true}
														inputProps={{
															value: address,
															onChange: (address) => this.onAddressChange(address, index),
															onFocus: (e) => this.onAddressFocus(e, index),
															placeholder: addressArray[0],
														}} />
											</div>
											{!(index === 0 || index === 1) && <i onClick={() => this.onRemoveStopPoint(index)} className="fas fa-minus-circle" />}
										</div>
									})}
									{!addressArray.includes("") && addressArray.length < 4  && <div className="wrap-input add-address" onClick={this.onAddStopPoint}><i className="fas fa-plus-circle mr-2" /><span>Thêm điểm đến</span></div>}

									<div className="wrap-input add-address">
										<label className="checkbox">
											<input type="checkbox" onChange={this.onWDWayCheckBoxChange} checked={wdOneWay}/>
											<span className="input-span" />
											<span> Tôi muốn đi 1 chiều</span>
										</label>
									</div>

									{wdOneWay ? <div className="info-way one-way wrap-input add-address"> 
										<p className="notice">Di chuyển xe ngoài thành phố, di chuyển 1 chiều. <a onClick={this.showInfoWdType} className="text-primary">Tìm hiểu thêm</a></p> 
									</div> 
									: 
									<div className="info-way two-way wrap-input add-address">
										<p>
											<i className="fas fa-flag mr-1"></i>
											Trả xe tại điểm đón	
										</p>
										<p className="notice">Di chuyển xe ngoài thành phố, di chuyển 2 chiều. <a onClick={this.showInfoWdType} className="text-primary">Tìm hiểu thêm</a></p> 
									</div>}

								</div>}

								<div className="form-group mb-4">
									<label className="home-label">Bắt đầu</label>
									<div className="d-flex">
										<div className="form-control form-control-line">
											<DateRangePicker
												startDate={this.state.startDatewd}
												endDate={this.state.startDatewd}
												minDate={moment()}
												maxDate={moment().add(3, "months")}
												timePicker={false}
												singleDatePicker={true}
												singleSelect={true}
												autoApply={true}
												isIOs={isIOS}
												timePickerIncrement={30}
												linkedCalendars={false}
												timePicker24Hour={true}
												onHide={this.onStartDateChange.bind(this)}
												buttonClasses={["hidden"]}
												opens={"center"}
												template={calendarTemplate}
												parentEl={"#home-box"}>
												<span className="value">{this.state.startDatewd ? this.state.startDatewd.format("DD/MM/YYYY") : "Chọn ngày"} <i className="i-chevron-down"></i></span>
											</DateRangePicker>
										</div>
										
											<select style={{height: "auto"}} className="form-control form-control-line"  onChange={this.onStartTimeChange.bind(this)} value={this.state.startTimewd}>
												{bookingTimes.map(time => <option key={`s_${time.value}`} value={time.value}>{time.label} </option>)}
											</select>
									</div>
								</div>
								<div className="form-group mb-4">
									<label className="home-label">Kết thúc</label>
									<div className="d-flex">
										<div className="form-control form-control-line">
											<DateRangePicker
												startDate={this.state.startDatewd}
												endDate={this.state.endDatewd}
												minDate={moment(this.state.startDatewd.valueOf())}
												maxDate={moment().add(3, "months")}
												timePicker={false}
												singleDateRangePicker={true}
												singleSelect={true}
												autoApply={true}
												isIOs={isIOS}
												timePickerIncrement={30}
												linkedCalendars={false}
												timePicker24Hour={true}
												pickingEndDateOnly={true}
												onHide={this.onDateRangeChange.bind(this)}
												buttonClasses={["hidden"]}
												opens={"center"}
												template={calendarTemplate}
												parentEl={"#home-box"}>
												<span className="value">{this.state.endDatewd ? this.state.endDatewd.format("DD/MM/YYYY") : "Chọn ngày"} <i className="i-chevron-down"></i></span>
											</DateRangePicker>
										</div>
			
											<select style={{height: "auto"}} className="form-control form-control-line"  onChange={this.onEndTimeChange.bind(this)} value={this.state.endTimewd}>
												{bookingTimes.map(time => <option key={`e_${time.value}`} value={time.value}>{time.label} </option>)}
											</select>
									</div>
									
								</div>
								{/* --> START/END DATE */}
								{this.state.wdDistance > 4000 ? <p className="text-danger font-13 marginBottom-xs">Không hỗ trợ lộ trình chuyến đi</p> : (this.state.hourValidateResult > -1 && <p className="text-danger font-13 marginBottom-xs">Thời gian thuê tối thiểu cho lộ trình trên là {this.state.hourValidateResult} tiếng.</p>)}

								<div className="fn-search text-center">
									<Link className="btn btn-primary" onClick={this.findCar} to={{
										pathname: `/withdriver/find/filter`,
										search: `startDate=${this.state.startDatewd.valueOf()}&endDate=${this.state.endDatewd.valueOf()}&address=${this.formatAddressArrayForQuery()}&wdMode=${wdMode}&wdOneWay=${wdOneWay}&platformType=${platformType}`
									}}>
										<span>TÌM XE NGAY</span>
									</Link>
								
								</div> 
						
								</div>
								<MessageBox show={errMsg !== ""} hideModal={this.hideMessageBox} message={errMsg} />
							</div>
						</div>

				}
				return <div className="mioto-layout page-wrapper">                                                    
								<Header />
								<SideBar />	
								<div className="content-wrapper" >
									<div className="page-content fade-in-up">
										<div className="ibox order-detail__sect">
											<div className="ibox-head">
												<div className="ibox-title">YÊU CẦU ĐẶT CHỖ</div>
											</div>
											<div className="ibox-body">
												<div className="row">
													<div className="col-md-2">
														<a className={`l-service ${stype === stypes.WD ? "active" : ""}`} onClick={this.setWdView}>
															<div className="service-box"><i className="ict ict-withdriver" />
																<p>Xe có tài</p>
														</div></a>
														<a className={`l-service ${stype === stypes.SD ? "active" : ""}`} onClick={this.setSdView}>
															<div className="service-box">
																<i className="ict ict-selfdrive" />
																<p>Xe tự lái</p>
																	</div></a>
													</div>

													<div className="col-md-10" id="home-box"> 
															{content}
														
													</div>
												</div>
											</div>
										</div>
									</div>
									<Footer />
								</div>
								<InfoWDType wdType={wdType} show={showInfoWdType} onHide={this.closeInfoWdType} />
					</div>
	}
}

function mapState(state) {
	return {
		appInit: state.appInit
	}
}

OrderSearching = connect(mapState)(OrderSearching)

export default OrderSearching




// WEBPACK FOOTER //
// ./src/components/car/ordersearching.js